// @flow

import type { PayType } from '../../types/benefit';

/* eslint-disable import/prefer-default-export */
export class PAY_TYPES {
  static COINS: PayType = 'coins';
  static COPAY: PayType = 'copay';
  static DUAL: PayType = 'dual';
}
